module.exports = __webpack_public_path__ + "07_face.01cb8c6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer1/07_face.png
// module id = FaDF
// module chunks = 0